import { llkProducts, whatsappLink } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";
import { StaggerContainer, StaggerItem } from "@/components/animations/StaggerContainer";
import { motion } from "motion/react";

export default function ProductsSection() {
  return (
    <section id="produtos" className="relative py-20 md:py-28 bg-llk-cream-2">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <ScrollReveal>
            <p className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-llk-gold-dark mb-4">
              NOSSOS PRODUTOS
            </p>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-llk-dark font-semibold mb-4">
              LLK Bio Solutions
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="text-llk-dark/60 text-base md:text-lg max-w-2xl mx-auto">
              Bioinsumos de alta performance para proteção, controle e ativação biológica da sua lavoura.
            </p>
          </ScrollReveal>
        </div>

        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" staggerDelay={0.12} delayChildren={0.15}>
          {llkProducts.map((product) => (
            <StaggerItem key={product.id}>
              <motion.div
                whileHover={{ y: -6, transition: { duration: 0.3 } }}
                className="group relative flex flex-col rounded-2xl overflow-hidden bg-white border border-llk-earth-pale/40 h-full"
              >
                {/* Badge */}
                {product.badge && (
                  <div className="absolute top-4 left-4 z-10 px-3 py-1 rounded-full bg-llk-dark text-white text-[11px] font-semibold">
                    {product.badge}
                  </div>
                )}

                {/* Product Image */}
                <div className={`relative flex items-center justify-center p-6 md:p-8 bg-gradient-to-br ${product.bgGradient} min-h-[180px] sm:min-h-[200px] md:min-h-[240px]`}>
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full max-w-[140px] sm:max-w-[160px] md:max-w-[180px] object-contain drop-shadow-2xl group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>

                {/* Info */}
                <div className="p-4 sm:p-5 md:p-6 flex flex-col flex-1">
                  <h3 className="text-base sm:text-lg md:text-xl font-semibold text-llk-dark mb-1">{product.name}</h3>
                  <p className="text-llk-gold text-xs sm:text-sm font-medium mb-2 sm:mb-3">{product.tagline}</p>

                  {/* Desktop: texto corrido */}
                  <p className="hidden sm:block text-llk-dark/70 text-sm mb-2">{product.focus}</p>
                  <p className="hidden sm:block text-llk-dark/50 text-xs mb-4 flex-1 leading-relaxed">{product.description}</p>

                  {/* Mobile: lista de features com checkmarks */}
                  <ul className="sm:hidden flex flex-col gap-2 mb-4 flex-1">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <i className="ri-check-line text-llk-gold text-xs mt-0.5 shrink-0" />
                        <span className="text-llk-dark/70 text-xs leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 w-full py-2.5 sm:py-3 bg-llk-dark text-white text-xs sm:text-sm font-medium rounded-xl hover:bg-llk-gold transition-colors whitespace-normal sm:whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line" />
                    Consultar no WhatsApp
                  </a>
                </div>
              </motion.div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}